import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["error", "disabled", "label", "id", "placeholder", "hintMessage", "maxLength", "onChange", "onFocus", "onBlur", "defaultValue", "value", "bgColor"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/TextAreaInput/TextAreaInput.js";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React, { Component } from 'react';
import styled from 'styled-components';
import { noop } from '../../helpers';
import Text from '../Text';
import HintText from '../../core/components/Forms/HintText';
import FormField from '../../core/components/Forms/FormField';
import FormInput from '../../core/components/Forms/FormInput';
import LabelText from '../../core/components/Forms/LabelText';
import FormFieldHint from '../../core/components/Forms/FormFieldHint';
import { withTheme } from '../../core/ThemeProvider';
var TextAreaInput = /*#__PURE__*/function (_Component) {
  _inherits(TextAreaInput, _Component);
  var _super = _createSuper(TextAreaInput);
  function TextAreaInput() {
    var _this;
    _classCallCheck(this, TextAreaInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      charCount: 0
    };
    return _this;
  }
  _createClass(TextAreaInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleCharCount();
    }
  }, {
    key: "handleCharCount",
    value: function handleCharCount() {
      if (this.props.maxLength) {
        this.setState({
          charCount: this.textareaRef.value ? this.textareaRef.value.length : 0
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        error = _this$props.error,
        disabled = _this$props.disabled,
        label = _this$props.label,
        id = _this$props.id,
        placeholder = _this$props.placeholder,
        hintMessage = _this$props.hintMessage,
        maxLength = _this$props.maxLength,
        _onChange = _this$props.onChange,
        onFocus = _this$props.onFocus,
        onBlur = _this$props.onBlur,
        defaultValue = _this$props.defaultValue,
        value = _this$props.value,
        bgColor = _this$props.bgColor,
        rest = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 49,
          columnNumber: 7
        }
      }), /*#__PURE__*/React.createElement(FormField, {
        htmlFor: id,
        disabled: disabled,
        error: error,
        defaultValue: defaultValue || value,
        "data-testid": "textarea-label-id",
        bgColor: bgColor,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 50,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement(FormInput, {
        as: "textarea",
        "data-testid": "inputField",
        rows: "8",
        id: id,
        placeholder: placeholder || ' ',
        disabled: disabled,
        maxLength: maxLength,
        onChange: function onChange(e) {
          _onChange(e);
          _this2.handleCharCount();
        },
        value: value,
        defaultValue: defaultValue,
        onFocus: onFocus,
        onBlur: onBlur,
        ref: function ref(textarea) {
          _this2.textareaRef = textarea;
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 58,
          columnNumber: 11
        }
      }), /*#__PURE__*/React.createElement(LabelText, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 79,
          columnNumber: 11
        }
      }, label)), /*#__PURE__*/React.createElement(MessageWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 81,
          columnNumber: 9
        }
      }, hintMessage && /*#__PURE__*/React.createElement(HintText, {
        error: error,
        "data-testid": "hintId",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 83,
          columnNumber: 13
        }
      }, hintMessage), maxLength && /*#__PURE__*/React.createElement(CharCount, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 89,
          columnNumber: 13
        }
      }, /*#__PURE__*/React.createElement(Text, {
        type: "smallBody",
        "data-testid": "counterId",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 90,
          columnNumber: 15
        }
      }, this.state.charCount, "/", maxLength))));
    }
  }]);
  return TextAreaInput;
}(Component);
TextAreaInput.defaultProps = {
  disabled: false,
  error: false,
  onChange: noop,
  bgColor: 'white'
};
var MessageWrapper = styled(FormFieldHint).withConfig({
  displayName: "TextAreaInput__MessageWrapper",
  componentId: "sc-1lxqrwp-0"
})(["display:flex;"]);
var CharCount = withTheme(styled.div.withConfig({
  displayName: "TextAreaInput__CharCount",
  componentId: "sc-1lxqrwp-1"
})(["flex:auto;text-align:right;margin-left:", "px;"], function (p) {
  return p.coreTheme.space_3;
}));
export default TextAreaInput;